/* eslint-disable react/display-name */
import {
  Box,
  Grid,
  Link,
  Typography,
  styled,
  Skeleton as MuiSkeleton,
} from '@mui/material';

const Skeleton = styled(MuiSkeleton)(({theme}) => ({
  margin: theme.spacing(1, 0),
}));

export default () => {
  return (
    <Box sx={{width: '100%'}} minHeight={'100vh'} px={2} py={0.5}>
      <Box>
        <Skeleton
          variant="rounded"
          sx={{width: {xxs: '100%', md: '50%'}}}
          height={21}
        />
        <Skeleton
          variant="rounded"
          sx={{width: {xxs: '100%', md: '50%'}}}
          height={21}
        />
      </Box>
      <Skeleton
        variant="rounded"
        sx={{width: '100%', mt: 2, borderRadius: 3, height: {xxs: 125, md: 85}}}
      />
      <Box width={'100%'} justifyContent={'center'} display={'flex'}>
        <Box width={'100%'} maxWidth={680} textAlign={'center'}>
          <Box mt={2}>
            {new Array(3).fill(0).map((_, index) => (
              <Skeleton
                key={`apply-flow-ske-${index}`}
                variant="rounded"
                sx={{width: '100%'}}
                height={21}
              />
            ))}
            <Skeleton variant="rounded" width={'100%'} height={320} />
          </Box>
        </Box>
      </Box>
      <Box
        position={'fixed'}
        bottom={0}
        display={'flex'}
        justifyContent={'flex-end'}
        height={100}
        alignItems={'center'}
        right={{xxs: 15, md: 40}}
      >
        <Box
          display={'flex'}
          // mt={2}
          // mr={1}
          gap={2}
          width={'fit-content'}
          alignItems={'center'}
        >
          <Skeleton
            variant="text"
            sx={{width: {xxs: 120, md: 200}}}
            height={20}
          />
          <Skeleton
            variant="rounded"
            sx={{width: {xxs: 150, md: 200, borderRadius: 30}}}
            height={50}
          />
        </Box>
      </Box>
    </Box>
  );
};
